import { useActivitiesStyles } from "@b2bportal/core-themes";
import { useModuleBEM } from "@b2bportal/core-themes";
import {
  CoreActivitiesComponent,
  type PlatformComponentProps,
} from "@b2bportal/core-types";
import { useI18nContext } from "@hopper-b2b/i18n";
import {
  ActivityLocationAutocomplete,
  DateRangePicker,
  useActivitySearch,
} from "@tenant/activities";
import clsx from "clsx";
import defaultStyles from "./ActivitySearch.module.scss";

export type ActivitySearchComponentProps = PlatformComponentProps;
export const ActivitySearch = ({
  children,
  className,
}: ActivitySearchComponentProps) => {
  const { context, handlers } = useActivitySearch();
  const { t } = useI18nContext();
  const styles = useActivitiesStyles(
    CoreActivitiesComponent.AvailabilityPage,
    defaultStyles
  );
  const [block] = useModuleBEM(styles, CoreActivitiesComponent.ActivitySearch);

  return (
    <div className={clsx(block, className)}>
      <form onSubmit={handlers.onFormSubmit}>
        <ActivityLocationAutocomplete
          label={context.locationLabel}
          value={context.place}
          onChange={handlers.handlePlaceChange}
          onFocus={handlers.handlePlaceFocus}
          error={context.formError?.place}
          id={"hotel-location-autocomplete"}
        />
        <DateRangePicker
          startDate={context.dateRange?.from}
          endDate={context.dateRange?.until}
          onStartDateChangeHandler={(date) => {
            handlers.handleDateRangeFromChange(date);
          }}
          onEndDateChangeHandler={(date) => {
            handlers.handleDateRangeUntilChange(date);
          }}
          dialogTitle={t("core-activities.search.date.title")}
          error={context.formError?.dateRange}
        />
        <button type="submit">{context.searchButtonLabel}</button>
        {children}
      </form>
    </div>
  );
};
